export default function initTab() {
  const tabLists = document.querySelectorAll("[data-tablist]");

  if (!tabLists.length) return;

  tabLists.forEach((tabList) => {
    const tabLinks = tabList.querySelectorAll("a");
    // Try to find tabcontent in closest section first, then in any parent container
    const tabContent =
      tabList.closest("section")?.querySelector("[data-tabcontent]") ||
      tabList.parentElement?.querySelector("[data-tabcontent]") ||
      tabList.closest(".mega-menu")?.querySelector("[data-tabcontent]") ||
      tabList.closest(".navigation")?.querySelector("[data-tabcontent]") ||
      tabList
        .closest(".navigation-dropdown")
        ?.querySelector("[data-tabcontent]");

    if (!tabContent || !tabLinks.length) return;

    const panels = tabContent.querySelectorAll(".panel");

    // Activate first tab by default
    if (tabLinks.length > 0) {
      tabLinks[0].classList.add("active");
      const firstPanelId = tabLinks[0].getAttribute("href").substring(1);
      const firstPanel = tabContent.querySelector(`#${firstPanelId}`);
      if (firstPanel) {
        firstPanel.classList.add("active");
      }
    }

    // Add click handlers
    tabLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();

        const targetId = link.getAttribute("href").substring(1);
        const targetPanel = tabContent.querySelector(`#${targetId}`);

        if (!targetPanel) return;

        // Remove active from all tabs and panels
        tabLinks.forEach((l) => l.classList.remove("active"));
        panels.forEach((p) => p.classList.remove("active"));

        // Add active to clicked tab and corresponding panel
        link.classList.add("active");
        targetPanel.classList.add("active");
      });
    });
  });
}
